function RiskBubble({ text, styleClass }){
    return <div className={styleClass + ' risk-bubble'}>
        <div className="inner-bubble">
            {text}
        </div>
    </div>
}

export default RiskBubble;